import React, { useEffect, useState, useMemo } from "react";
import { useHistory, generatePath } from "react-router-dom";
import questionService from "../../services/questionService";
import Question from "../questions/question";
import Loading from "../common/loading";
import "./air.css";
import userService from "../../services/userService";

const AIRQuiz = ({ description, noOfQuestions, props }) => {
  console.log("AIRQuiz props:", props);
  // const questionId = "props.match.params.id";
  const queryID = props.match.params.id ? Number(props.match.params.id) : 1;
  const course = "air";
  const id = "quiz";
  const beforeQuizUrl = "/ethics/ai-regulations/page=7";
  const afterQuizUrl = "/ethics/ai-regulations/page=end";

  const [isLoading, setLoading] = useState(true);
  const [questionId, setQuestionId] = useState(queryID);
  const [answers, setAnswers] = useState();
  // const [questions, setQuestions] = useState();
  const [currentQuestion, setCurrentQuestion] = useState();
  const [isFreshReload, setIsFreshReload] = useState(true);
  const [totalPoints, setTotalPoints] = useState(0);

  const selectedAnswers = useMemo(() => {
    if (answers && answers.answers) {
      return answers.answers;
    } else {
      return [];
    }
  }, [answers]);

  const allowSubmit = useMemo(() => {
    if (answers && answers.num_attempts >= 3) {
      return false;
    }
    if (answers && answers.correct) {
      return false;
    }
    return true;
  }, [answers]);

  const correct = useMemo(() => {
    if (answers) {
      return answers.correct;
    } else {
      return false;
    }
  }, [answers]);

  useEffect(() => {
    console.log("AIRQuiz mounted");

    if (description) {
      // setQuestionId(description.id);
      setCurrentQuestion(description[queryID - 1]);
      // console.log("currentQuestion:", description[queryID - 1]);
      // Fetch user attempts and stats
      reloadBackendState();

      // setLoading(false);
    }
  }, [description]);

  const reloadBackendState = () => {
    questionService
      .getQuestionByChapterId(course, id)
      .then(({ data: response }) => {
        let questionAnswers = response.find(
          (p) => p.quiz_id === parseInt(questionId)
        );
        // console.log("Found attempt:", questionAnswers);
        setAnswers(questionAnswers);
        setLoading(false);
      });
    updateTotalPoints();
  };

  const updateTotalPoints = () => {
    userService.getScoresForCourse(course).then(({ data: response }) => {
      const chapters = response.filter(
        (item) => item.chapter_id.split("_")[0] === id.split("_")[0]
      );
      const sum = chapters.reduce(
        (sumPoints, chapter) => sumPoints + chapter.points,
        0
      );
      setTotalPoints(sum);
    });
  };

  const onSelectAnswer = (id, index) => {
    const question = { ...currentQuestion };
    question.answers[index].checked = !currentQuestion.answers[index].checked;
    setCurrentQuestion(question);
  };

  const onPrev = () => {
    if (questionId && questionId > 1) {
      let id = parseInt(questionId) - 1;
      props.history.push(generatePath(props.match.path, { id }));
    } else {
      props.history.push(beforeQuizUrl);
    }
  };

  const onNext = () => {
    if (questionId && questionId < noOfQuestions) {
      let id = parseInt(questionId) + 1;
      props.history.push(generatePath(props.match.path, { id }));
    } else {
      props.history.push(afterQuizUrl);
    }
  };

  const getMessage = () => {
    let message = "";
    let color = "";
    if (answers) {
      if (isFreshReload && (answers.correct || answers.num_attempts === 3)) {
        message = "Musterlösung - dies sind alle korrekten Antworten!";
        color = "";
      } else if (answers.num_attempts < 3) {
        if (answers.correct) {
          message = "Super. Du hast Punkte gesammelt.";
          color = "message-correct";
          console.log("message-correct");
        } else {
          message = "Noch nicht ganz richtig. Versuche es nochmal.";
          color = "message-more";
        }
      } else if (answers.num_attempts === 3) {
        if (answers.correct) {
          message = "Super. Du hast Punkte gesammelt.";
          color = "message-correct";
        } else {
          if (answers.correct_answers_count === 0) {
            message = "Schade, diesmal hast du leider keine Punkte gesammelt.";
            color = "message-wrong";
          } else if (answers.correct_answers_count > 0) {
            message =
              "Du erhältst Punkte, abzüglich der falsch gewählten Antworten.";
            color = "message-partial";
          }
        }
      }
    }
    return { message: message, color: color };
  };

  const onSubmit = () => {
    let questionSubmit = {
      id: currentQuestion.id,
      chapterId: id,
      type: course,
      answers: currentQuestion.answers,
    };
    questionService
      .submitQuestions(questionSubmit)
      .then(({ data: response }) => {
        reloadBackendState();
        console.log("Question submitted:", response);
        setAnswers(response.answers);
        setIsFreshReload(false);
      });
  };

  const getNextButtonLabel = () => {
    if (questionId && questionId < noOfQuestions) {
      return "Nächste Frage";
    } else {
      return "Weiter";
    }
  };

  const getPrevButtonLabel = () => {
    if (questionId && questionId > 1) {
      return "Vorherige Frage";
    } else {
      return "Zurück";
    }
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <section className="air-quiz content question">
          <div className="container-fluid">
            <h2> QUIZ </h2>
            <div className="question-wrapper">
              <Question
                correct={correct}
                key={currentQuestion.id}
                question={currentQuestion}
                onChange={onSelectAnswer}
                type="ethics"
                selectedAnswers={selectedAnswers}
                showAnswers={!allowSubmit}
                course={course}
              />
            </div>
            {!(getMessage().message === "") && (
              <div className={`question-info ${getMessage().color}`}>
                <span>{getMessage().message}</span>
              </div>
            )}

            {noOfQuestions > 0 && (
              <div className="air-quiz button-wrapper">
                <div className="points-panel-wrapper">
                  <span>Punkte</span>
                  <div className="points-panel">{totalPoints}</div>
                </div>
                {
                  <button onClick={onPrev} className="firstBtn">
                    {getPrevButtonLabel()}
                  </button>
                }
                {allowSubmit && (
                  <button
                    onClick={onSubmit}
                    className="secondBtn primary-color-lightblue-foreground"
                  >
                    Auswerten
                  </button>
                )}
                {true && (
                  <button onClick={onNext} className="thirdBtn">
                    {getNextButtonLabel()}
                  </button>
                )}
              </div>
            )}
          </div>
        </section>
      )}
    </>
  );
};

export default AIRQuiz;
